import React from "react";
import { Button, Checkbox, makeStyles, TextField } from "@material-ui/core";
import CheckBoxIcon from "@material-ui/icons/CheckBox";
import CheckBoxOutlineBlankIcon from "@material-ui/icons/CheckBoxOutlineBlank";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { useIntl } from "react-intl";
import { height } from "@mui/system";
const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;
interface selectProps {
  onChange: (e: any, newMember: any) => void;
  options: any[];
  buttontext?: string;
  onclick?: () => void;
  placeholder?: string;
}
export const SelectCheck = ({
  onChange,
  options,
  buttontext,
  onclick,
  placeholder,
}: selectProps) => {
  const { formatMessage } = useIntl();
  const classes = useStyles();
  return (
    <Autocomplete
      multiple
      id="checkboxes-tags-demo"
      options={options}
      disableCloseOnSelect
      getOptionLabel={(option) => option?.firstName}
      onChange={(e, newMember) => onChange(e, newMember)}
      renderOption={(option, { selected }) => (
        <React.Fragment>
          <Checkbox
            icon={icon}
            checkedIcon={checkedIcon}
            style={{ marginRight: 8 }}
            checked={selected}
          />
          {option?.firstName}
          &nbsp;&nbsp;
          {option?.lastName}
        </React.Fragment>
      )}
      classes={{ input: classes.input, inputRoot: classes.inputRoot }}
      style={{ width: "100%" }}
      renderInput={(params) => (
        <TextField {...params} variant="outlined" placeholder={placeholder} />
      )}
      noOptionsText={
        buttontext === "button" ? (
          <Button onMouseDown={onclick}>create Group</Button>
        ) : null
      }
    />
  );
};
const useStyles = makeStyles({
  input: {
    padding: "1.5px 4px !important",
  },
  inputRoot: {
    height: "55px !important",
  },
});
